import gql from 'graphql-tag'

import { toGqlTypes, toGqlArgs, toGqlFields } from '../utils/string'

const login = gql`
	mutation(
		$lsid: ID!
		$password: String!
		$appVersion: String!
		$apiKey: String!
		$organization: ID!
		$ssoId: String!
	) {
		login(
			lsid: $lsid
			password: $password
			clientInfo:{
				appVersion:$appVersion
			}
			apiKey: $apiKey
			organization:$organization
			ssoId: $ssoId
		) {
			accessToken
			refreshToken
         sessionID
         notiChangePwdFlag
         appUsername
		}
	}
`

const setupPassword = gql`
	mutation(
		$verificationCode: String!
		$citizenId: String!
		$lsid: ID!
		$birthDate: Date!
		$password: String!
		$confirmPassword: String!
		$policyId: ID,
		$organization: String!
	) {
		setupPassword(
			verificationCode:$verificationCode
			citizenId:$citizenId
			lsid:$lsid
			birthDate:$birthDate
			password:$password
			confirmPassword:$confirmPassword
			policyId: $policyId
			organization: $organization
			){
				status
		}
	}
`

const changePassword = gql`
	mutation(
		$oldPassword: String!
		$newPassword: String!
		$confirmNewPassword: String!
	){
		changePassword(
			oldPassword: $oldPassword
			newPassword: $newPassword
			confirmNewPassword: $confirmNewPassword
		){
		status
		}
	}
`

const createConsent = gql`
	mutation(
		$policyId: ID
		$confirmation: StatusConsent
	){
		createConsent(
			policyId: $policyId
			confirmation: $confirmation
		){
			status
		}
	}
`

const sendVerifyCode = gql`
	mutation(
		$email: String!
	){
		sendVerifyCode(
		email: $email
		){
		status
		}
	}
`

const changeCurrentProfile = gql`
	mutation(
		$currentProfle: String!
	){
		changeCurrentProfile(
			currentProfle: $currentProfle
		){
			status
		}
	}
`

const logout = gql`
	mutation{
		logout{
			status
		}
	}
`

const createUserReadNotification = gql`
	mutation(
		$notificationId: ID!
	){
		createUserReadNotification(
			notificationId: $notificationId
		){
			status
		}
	}
`

const createUserResultNotification = gql`
	mutation(
		$notificationId: ID!
	){
		createUserResultNotification(
			notificationId: $notificationId
		){
			status
		}
	}
`

const requestVerifyOTPandSetupPassword = gql`
	mutation(
    $lsid: ID!
    $verificationCode: String!
    $citizenId: String!
    $birthDate: Date!
    $organization: String!
    $password: String!
    $confirmPassword: String!
    $telNo: String!
    $otp: OtpInput!
  ){
    requestVerifyOTPandSetupPassword(
      lsid: $lsid
      verificationCode: $verificationCode
      citizenId: $citizenId
      birthDate: $birthDate
      organization: $organization
      password: $password
      confirmPassword: $confirmPassword
      telNo: $telNo
      otp: $otp
    ){
      status
    }
  }
`

const resetPassword = gql`
	mutation(
		$lsid: ID!
		$identityCard: String!
		$verificationCode: String!
		$birthDate: Date!
		$organization: String!
		$password: String!
		$confirmPassword: String!
		){
		resetPassword(
			lsid: $lsid
			identityCard: $identityCard
			verificationCode: $verificationCode
			birthDate: $birthDate
			organization: $organization
			password: $password
			confirmPassword: $confirmPassword
		){
			status
		}
	}
`

const createTaxDraft = gql`
	mutation(
		$childBirthBefore2561: Int!
		$childBirthAfter2561: Int!
		$adoptedChild: Int!
		$isSponserFather: Int!
		$isFatherHealthInsurance: Int!
		$isSponserMother: Int!
		$isMotherHealthInsurance: Int!
		$isSponserSpouFather: Int!
		$spouFatherTitle: String!
		$spouFatherFname: String!
		$spouFatherLname: String!
		$spouFatherIdentNo: String!
		$spouFatherReduAmnt: Decimal!
		$fatherHealthInsurance: Decimal!
		$isSpouFatherHealthInsurance: Int!
		$spouFaHealthInsurance: Decimal!
		$isSponserSpouMother: Int!
		$spouMotherTitle: String!
		$spouMotherFname: String!
		$spouMotherLname: String!
		$spouMotherIdentNo: String!
		$spouMotherReduAmnt: Decimal!
		$matherHealthInsurance: Decimal!
		$isSpouMotherHealthInsurance: Int!
		$spouMaHealthInsurance: Decimal!
		$isSponserDisabled: Int
		$isNumberOfDisabled: Int
		$employeeName1: String
		$idCardDisabled1: String
		$lessAllowance1: Decimal
		$relation1: String
		$employeeName2: String
		$idCardDisabled2: String
		$lessAllowance2: Decimal
		$relation2: String
		$employeeName3: String
		$idCardDisabled3: String
		$lessAllowance3: Decimal
		$relation3: String
		$employeeName4: String
		$idCardDisabled4: String
		$lessAllowance4: Decimal
		$relation4: String
		$employeeName5: String
		$idCardDisabled5: String
		$lessAllowance5: Decimal
		$relation5: String
		$employeeName6: String
		$idCardDisabled6: String
		$lessAllowance6: Decimal
		$relation6: String
		$employeeName7: String
		$idCardDisabled7: String
		$lessAllowance7: Decimal
		$relation7: String
		$employeeName8: String
		$idCardDisabled8: String
		$lessAllowance8: Decimal
		$relation8: String
		$employeeName9: String
		$idCardDisabled9: String
		$lessAllowance9: Decimal
		$relation9: String
		$employeeName10: String
		$idCardDisabled10: String
		$lessAllowance10: Decimal
		$relation10: String
		$healthInsurance: Decimal!
		$insuraAmount: Decimal!
		$rmfDeposit: Decimal!
		$ssfDeposit: Decimal
		$interestLoan: Decimal!
		$accumulateSocial: Decimal!
		$donationEducate: Decimal!
		$donationCharityNote: String
		$donationCharity: Decimal!
		$isDelete: Int!
		$fatherTitle: String
		$fatherFname: String
		$fatherLname: String
		$fatherIdentNo: String
		$fatherReduAmnt: Decimal
		$motherTitle: String
		$motherFname: String
		$motherLname: String
		$motherIdentNo: String
		$motherReduAmnt: Decimal
	){
		createTaxDraft(
			childBirthBefore2561: $childBirthBefore2561
			childBirthAfter2561: $childBirthAfter2561
			adoptedChild: $adoptedChild
			isSponserFather: $isSponserFather
			isFatherHealthInsurance: $isFatherHealthInsurance
			isSponserMother: $isSponserMother
			isMotherHealthInsurance: $isMotherHealthInsurance
			isSponserSpouFather: $isSponserSpouFather
			spouFatherTitle: $spouFatherTitle
			spouFatherFname: $spouFatherFname
			spouFatherLname: $spouFatherLname
			spouFatherIdentNo: $spouFatherIdentNo
			spouFatherReduAmnt: $spouFatherReduAmnt
			fatherHealthInsurance: $fatherHealthInsurance
			isSpouFatherHealthInsurance: $isSpouFatherHealthInsurance
			spouFaHealthInsurance: $spouFaHealthInsurance
			isSponserSpouMother: $isSponserSpouMother
			spouMotherTitle: $spouMotherTitle
			spouMotherFname: $spouMotherFname
			spouMotherLname: $spouMotherLname
			spouMotherIdentNo: $spouMotherIdentNo
			spouMotherReduAmnt: $spouMotherReduAmnt
			matherHealthInsurance: $matherHealthInsurance
			isSpouMotherHealthInsurance: $isSpouMotherHealthInsurance
			spouMaHealthInsurance: $spouMaHealthInsurance
			isSponserDisabled: $isSponserDisabled
			isNumberOfDisabled: $isNumberOfDisabled
			employeeName1: $employeeName1
			idCardDisabled1: $idCardDisabled1
			lessAllowance1: $lessAllowance1
			relation1: $relation1
			employeeName2: $employeeName2
			idCardDisabled2: $idCardDisabled2
			lessAllowance2: $lessAllowance2
			relation2: $relation2
			employeeName3: $employeeName3
			idCardDisabled3: $idCardDisabled3
			lessAllowance3: $lessAllowance3
			relation3: $relation3
			employeeName4: $employeeName4
			idCardDisabled4: $idCardDisabled4
			lessAllowance4: $lessAllowance4
			relation4: $relation4
			employeeName5: $employeeName5
			idCardDisabled5: $idCardDisabled5
			lessAllowance5: $lessAllowance5
			relation5: $relation5
			employeeName6: $employeeName6
			idCardDisabled6: $idCardDisabled6
			lessAllowance6: $lessAllowance6
			relation6: $relation6
			employeeName7: $employeeName7
			idCardDisabled7: $idCardDisabled7
			lessAllowance7: $lessAllowance7
			relation7: $relation7
			employeeName8: $employeeName8
			idCardDisabled8: $idCardDisabled8
			lessAllowance8: $lessAllowance8
			relation8: $relation8
			employeeName9: $employeeName9
			idCardDisabled9: $idCardDisabled9
			lessAllowance9: $lessAllowance9
			relation9: $relation9
			employeeName10: $employeeName10
			idCardDisabled10: $idCardDisabled10
			lessAllowance10: $lessAllowance10
			relation10: $relation10
			healthInsurance: $healthInsurance
			insuraAmount: $insuraAmount
			rmfDeposit: $rmfDeposit
			ssfDeposit: $ssfDeposit
			interestLoan: $interestLoan
			accumulateSocial: $accumulateSocial
			donationEducate: $donationEducate
			donationCharityNote: $donationCharityNote
			donationCharity: $donationCharity
			isDelete: $isDelete
			fatherTitle: $fatherTitle
			fatherFname: $fatherFname
			fatherLname: $fatherLname
			fatherIdentNo: $fatherIdentNo
			fatherReduAmnt: $fatherReduAmnt
			motherTitle: $motherTitle
			motherFname: $motherFname
			motherLname: $motherLname
			motherIdentNo: $motherIdentNo
			motherReduAmnt: $motherReduAmnt
		){
			status
		}
	}
`

const updateTaxDraft = gql`
	mutation(
		$taxDraftId: ID!
		$childBirthBefore2561: Int!
		$childBirthAfter2561: Int!
		$adoptedChild: Int!
		$isSponserFather: Int!
		$isFatherHealthInsurance: Int!
		$isSponserMother: Int!
		$isMotherHealthInsurance: Int!
		$isSponserSpouFather: Int!
		$spouFatherTitle: String!
		$spouFatherFname: String!
		$spouFatherLname: String!
		$spouFatherIdentNo: String!
		$spouFatherReduAmnt: Decimal!
		$fatherHealthInsurance: Decimal!
		$isSpouFatherHealthInsurance: Int!
		$spouFaHealthInsurance: Decimal!
		$isSponserSpouMother: Int!
		$spouMotherTitle: String!
		$spouMotherFname: String!
		$spouMotherLname: String!
		$spouMotherIdentNo: String!
		$spouMotherReduAmnt: Decimal!
		$matherHealthInsurance: Decimal!
		$isSpouMotherHealthInsurance: Int!
		$spouMaHealthInsurance: Decimal!
		$isSponserDisabled: Int
		$isNumberOfDisabled: Int
		$employeeName1: String
		$idCardDisabled1: String
		$lessAllowance1: Decimal
		$relation1: String
		$employeeName2: String
		$idCardDisabled2: String
		$lessAllowance2: Decimal
		$relation2: String
		$employeeName3: String
		$idCardDisabled3: String
		$lessAllowance3: Decimal
		$relation3: String
		$employeeName4: String
		$idCardDisabled4: String
		$lessAllowance4: Decimal
		$relation4: String
		$employeeName5: String
		$idCardDisabled5: String
		$lessAllowance5: Decimal
		$relation5: String
		$employeeName6: String
		$idCardDisabled6: String
		$lessAllowance6: Decimal
		$relation6: String
		$employeeName7: String
		$idCardDisabled7: String
		$lessAllowance7: Decimal
		$relation7: String
		$employeeName8: String
		$idCardDisabled8: String
		$lessAllowance8: Decimal
		$relation8: String
		$employeeName9: String
		$idCardDisabled9: String
		$lessAllowance9: Decimal
		$relation9: String
		$employeeName10: String
		$idCardDisabled10: String
		$lessAllowance10: Decimal
		$relation10: String
		$healthInsurance: Decimal!
		$insuraAmount: Decimal!
		$rmfDeposit: Decimal!
		$ssfDeposit: Decimal
		$interestLoan: Decimal!
		$accumulateSocial: Decimal!
		$donationEducate: Decimal!
		$donationCharityNote: String
		$donationCharity: Decimal!
		$isDelete: Int!
		$fatherTitle: String
		$fatherFname: String
		$fatherLname: String
		$fatherIdentNo: String
		$fatherReduAmnt: Decimal
		$motherTitle: String
		$motherFname: String
		$motherLname: String
		$motherIdentNo: String
		$motherReduAmnt: Decimal
	){
		updateTaxDraft(
			taxDraftId: $taxDraftId
			childBirthBefore2561: $childBirthBefore2561
			childBirthAfter2561: $childBirthAfter2561
			adoptedChild: $adoptedChild
			isSponserFather: $isSponserFather
			isFatherHealthInsurance: $isFatherHealthInsurance
			isSponserMother: $isSponserMother
			isMotherHealthInsurance: $isMotherHealthInsurance
			isSponserSpouFather: $isSponserSpouFather
			spouFatherTitle: $spouFatherTitle
			spouFatherFname: $spouFatherFname
			spouFatherLname: $spouFatherLname
			spouFatherIdentNo: $spouFatherIdentNo
			spouFatherReduAmnt: $spouFatherReduAmnt
			fatherHealthInsurance: $fatherHealthInsurance
			isSpouFatherHealthInsurance: $isSpouFatherHealthInsurance
			spouFaHealthInsurance: $spouFaHealthInsurance
			isSponserSpouMother: $isSponserSpouMother
			spouMotherTitle: $spouMotherTitle
			spouMotherFname: $spouMotherFname
			spouMotherLname: $spouMotherLname
			spouMotherIdentNo: $spouMotherIdentNo
			spouMotherReduAmnt: $spouMotherReduAmnt
			matherHealthInsurance: $matherHealthInsurance
			isSpouMotherHealthInsurance: $isSpouMotherHealthInsurance
			spouMaHealthInsurance: $spouMaHealthInsurance
			isSponserDisabled: $isSponserDisabled
			isNumberOfDisabled: $isNumberOfDisabled
			employeeName1: $employeeName1
			idCardDisabled1: $idCardDisabled1
			lessAllowance1: $lessAllowance1
			relation1: $relation1
			employeeName2: $employeeName2
			idCardDisabled2: $idCardDisabled2
			lessAllowance2: $lessAllowance2
			relation2: $relation2
			employeeName3: $employeeName3
			idCardDisabled3: $idCardDisabled3
			lessAllowance3: $lessAllowance3
			relation3: $relation3
			employeeName4: $employeeName4
			idCardDisabled4: $idCardDisabled4
			lessAllowance4: $lessAllowance4
			relation4: $relation4
			employeeName5: $employeeName5
			idCardDisabled5: $idCardDisabled5
			lessAllowance5: $lessAllowance5
			relation5: $relation5
			employeeName6: $employeeName6
			idCardDisabled6: $idCardDisabled6
			lessAllowance6: $lessAllowance6
			relation6: $relation6
			employeeName7: $employeeName7
			idCardDisabled7: $idCardDisabled7
			lessAllowance7: $lessAllowance7
			relation7: $relation7
			employeeName8: $employeeName8
			idCardDisabled8: $idCardDisabled8
			lessAllowance8: $lessAllowance8
			relation8: $relation8
			employeeName9: $employeeName9
			idCardDisabled9: $idCardDisabled9
			lessAllowance9: $lessAllowance9
			relation9: $relation9
			employeeName10: $employeeName10
			idCardDisabled10: $idCardDisabled10
			lessAllowance10: $lessAllowance10
			relation10: $relation10
			healthInsurance: $healthInsurance
			insuraAmount: $insuraAmount
			rmfDeposit: $rmfDeposit
			ssfDeposit: $ssfDeposit
			interestLoan: $interestLoan
			accumulateSocial: $accumulateSocial
			donationEducate: $donationEducate
			donationCharityNote: $donationCharityNote
			donationCharity: $donationCharity
			isDelete: $isDelete
			fatherTitle: $fatherTitle
			fatherFname: $fatherFname
			fatherLname: $fatherLname
			fatherIdentNo: $fatherIdentNo
			fatherReduAmnt: $fatherReduAmnt
			motherTitle: $motherTitle
			motherFname: $motherFname
			motherLname: $motherLname
			motherIdentNo: $motherIdentNo
			motherReduAmnt: $motherReduAmnt
		){
			status
		}
	}
`

const createAddress = gql`
	mutation(
		$addressName: String
		$addressNo: String
		$groupNo: String
		$building: String
		$roomNo: String
		$floorNo: String
		$vilage: String
		$lane: String
		$street: String
		$district: String
		$amphur: String
		$province: String
		$postalCode: String
		$country: String
		$email1: String
		$phone1: String
		$isDelete: Int!
	){
		createAddress(
			addressName: $addressName
			addressNo: $addressNo
			groupNo: $groupNo
			building: $building
			roomNo: $roomNo
			floorNo: $floorNo
			vilage: $vilage
			lane: $lane
			street: $street
			district: $district
			amphur: $amphur
			province: $province
			postalCode: $postalCode
			country: $country
			email1: $email1
			phone1: $phone1
			isDelete: $isDelete
		){
			status
		}
	}
`

const updateAddress = gql`
	mutation(
		$addressId: ID!
		$addressName: String
		$addressNo: String
		$groupNo: String
		$building: String
		$roomNo: String
		$floorNo: String
		$vilage: String
		$lane: String
		$street: String
		$district: String
		$amphur: String
		$province: String
		$postalCode: String
		$country: String
		$email1: String
		$phone1: String
		$isDelete: Int!
	){
		updateAddress(
			addressId: $addressId
			addressName: $addressName
			addressNo: $addressNo
			groupNo: $groupNo
			building: $building
			roomNo: $roomNo
			floorNo: $floorNo
			vilage: $vilage
			lane: $lane
			street: $street
			district: $district
			amphur: $amphur
			province: $province
			postalCode: $postalCode
			country: $country
			email1: $email1
			phone1: $phone1
			isDelete: $isDelete
		){
			status
		}
	}
`

const createPostRead = gql`
	mutation(
		$postId: ID!
	){
		createPostRead(
			postId: $postId
		){
			status
		}
	}
`

const changePhoneNumber = gql`
	mutation(
		$telNo: String!
		$otp: OtpInput!
	){
		changePhoneNumber(
			telNo: $telNo
			otp: $otp
		){
			status
		}
	}
`

const createWDHospital = gql`
	mutation(
		$empFirstName: String
		$empLastName: String
		$withdrawFirstName: String
		$withdrawLastName: String
		$relation: String
		$age: Int
		$department: String
		$division: String
		$totalWithdraw: Decimal
		$date: Date
		$status: String
		$hospitalName: String
		$hospitalType: String
		$sicknessName: String
		$sicknessId: String
		$patientType: String
		$privateCase: String
		$note: String
		$noteApprove: String
		$slip: [DataSlip]
		$approvers: [Approver]
		$document: [Documents]
		$medCertDoc: [DocumentMulti]
		$empAffiliationOrgCode: String,
        $isPension: Boolean
	){
		createWDHospital(
			empFirstName: $empFirstName
			empLastName: $empLastName
			withdrawFirstName: $withdrawFirstName
			withdrawLastName: $withdrawLastName
			relation: $relation
			age: $age
			department: $department
			division: $division
			totalWithdraw: $totalWithdraw
			date: $date
			status: $status
			hospitalName: $hospitalName
			hospitalType: $hospitalType
			sicknessName: $sicknessName
			sicknessId: $sicknessId
			patientType: $patientType
			privateCase: $privateCase
			note: $note
			noteApprove: $noteApprove
			slip: $slip
			approvers:$approvers
			document: $document
			medCertDoc: $medCertDoc
			empAffiliationOrgCode: $empAffiliationOrgCode,
            isPension: $isPension
		){
			status
		}
	}
`

const updateWDHospital = gql`
	mutation(
		$wdHospitalId: ID!
		$empFirstName: String
		$empLastName: String
		$withdrawFirstName: String
		$withdrawLastName: String
		$relation: String
		$age: Int
		$department: String
		$division: String
		$totalWithdraw: Decimal
		$date: Date
		$status: String
		$hospitalName: String
		$hospitalType: String
		$sicknessName: String
		$sicknessId: String
		$patientType: String
		$privateCase: String
		$note: String
		$noteApprove: String
		$totalCurrentWithdraw: Decimal
		$slip: [DataSlip]
		$approvers: [Approver]
		$document: [Documents]
		$documentMulti: [DocumentMulti]
		$isJuristic: Boolean
		$hospitalBankAccountId: ID
		$withdrawIdCard: String
		$medCertDoc: [DocumentMulti]
		$treatmentStartDate: Date
		$treatmentEndDate: Date
		$refDocument: String
		$cashFlg: String
		$deletedFileId: [String]
		$coaCodeName: String
		$isPension: Boolean
		$empAffiliationOrgCode: String
	){
		updateWDHospital(
			wdHospitalId: $wdHospitalId
			empFirstName: $empFirstName
			empLastName: $empLastName
			withdrawFirstName: $withdrawFirstName
			withdrawLastName: $withdrawLastName
			relation: $relation
			age: $age
			department: $department
			division: $division
			totalWithdraw: $totalWithdraw
			date: $date
			status: $status
			hospitalName: $hospitalName
			hospitalType: $hospitalType
			sicknessName: $sicknessName
			sicknessId: $sicknessId
			patientType: $patientType
			privateCase: $privateCase
			note: $note
			noteApprove: $noteApprove
			totalCurrentWithdraw:$totalCurrentWithdraw
			slip: $slip
			approvers:$approvers
			document: $document
			isJuristic: $isJuristic
			hospitalBankAccountId: $hospitalBankAccountId
			documentMulti: $documentMulti
			withdrawIdCard: $withdrawIdCard
			medCertDoc: $medCertDoc
			treatmentStartDate: $treatmentStartDate
			treatmentEndDate: $treatmentEndDate
			refDocument: $refDocument
			cashFlg: $cashFlg
			deletedFileId: $deletedFileId
			coaCodeName: $coaCodeName
			isPension: $isPension
			empAffiliationOrgCode: $empAffiliationOrgCode
		){
			status
		}
	}
`

const destroyWDHospital = gql`
	mutation(
		$wdHospitalId: ID!
	){
		destroyWDHospital(
			wdHospitalId: $wdHospitalId
		){
			status
		}
	}
`

const destroyWDSlip = gql`
	mutation(
		$wdSlipId: ID!
	){
		destroyWDSlip(
			wdSlipId: $wdSlipId
		){
			status
		}
	}
`

// const createLeaveDocument = gql`
// 	mutation(
// 		$empCode: String
// 		$documentDate: Date!
// 		$leaveTypeId: ID!
// 		$leaveStartDate: Date!
// 		$leaveEndDate: Date!
// 		$durationType: String!
// 		$leaveDay: Float!
// 		$description: String!
// 		$approveStatus: String!
// 		$approvers: [Approver]
// 		$attachFiles: [AttachFile]
// 		$department: String
// 		$division: String
// 		$employeeName: String
// 		$isReqByEmp: Boolean
     
// 	){
// 		createLeaveDocument(
// 			empCode: $empCode
// 			documentDate: $documentDate
// 			leaveTypeId: $leaveTypeId
// 			leaveStartDate: $leaveStartDate
// 			leaveEndDate: $leaveEndDate
// 			durationType: $durationType
// 			leaveDay: $leaveDay
// 			description: $description
// 			approveStatus: $approveStatus
// 			approvers: $approvers
// 			attachFiles: $attachFiles
// 			department: $department
// 			division: $division
// 			employeeName: $employeeName
// 			isReqByEmp: $isReqByEmp
// 		){
// 			docId
// 			errorMessage
// 			attachmentCreatedResponse{
// 				fileId
// 				errorMessage
// 			}
// 		}
// 	}
// `

const createLeaveDocument = gql`
	mutation(
		$empCode: String
      $documentDate: Date!
      $leaveTypeId: ID!
      $leaveStartDate: Date!
      $leaveEndDate: Date!
      $durationType: String!
      $leaveDay: Float!
      $leaveDayAll: Float
      $description: String!
      $approveStatus: String!
      $orgName: String!
      $orgCode: String!
      $approvers: [Approver]
      $attachFiles: [AttachFile]
      $department: String
      $division: String
      $employeeName: String
      $isReqByEmp: Boolean
      $shiftId: String
      $leaveStartTime: String
      $leaveEndTime: String
      $leaveHour: String
      $sourceDB: String
      $noteApprove: String
      $autoApprove: Boolean!
      $wdLeaveId: String
      $operatorFullname: String
      $clientType: String!
      $shiftTime: String
      $shiftCode: String
	  $subDeptCode:String
      $subDeptName:String
      $childSubDeptCode:String
      $childSubDeptName:String
	){
		createLeaveDocument(
			empCode: $empCode
         documentDate: $documentDate
         leaveTypeId: $leaveTypeId
         leaveStartDate: $leaveStartDate
         leaveEndDate: $leaveEndDate
         durationType: $durationType
         leaveDay: $leaveDay
         leaveDayAll: $leaveDayAll
         description: $description
         approveStatus: $approveStatus
         orgName: $orgName
         orgCode: $orgCode
         approvers: $approvers
         attachFiles: $attachFiles
         department: $department
         division: $division
         employeeName: $employeeName
         isReqByEmp: $isReqByEmp
         shiftId: $shiftId
         leaveStartTime: $leaveStartTime
         leaveEndTime: $leaveEndTime
         leaveHour: $leaveHour
         sourceDB: $sourceDB
         noteApprove: $noteApprove
         autoApprove: $autoApprove
         wdLeaveId: $wdLeaveId
         operatorFullname: $operatorFullname
         clientType: $clientType
         shiftTime: $shiftTime
         shiftCode: $shiftCode
		 subDeptCode:$subDeptCode
		 subDeptName:$subDeptName
		 childSubDeptCode:$childSubDeptCode
		 childSubDeptName: $childSubDeptName
		){
			docId
			errorMessage
			attachmentCreatedResponse{
				fileId
				errorMessage
			}
		}
	}
`


const updateLeaveDocument = gql`
	mutation(
		$empCode: String
		$docId: ID!
		$documentDate: Date
		$leaveTypeId: ID
		$leaveStartDate: Date
		$durationType: String!
		$leaveEndDate: Date
		$leaveDay: Float
		$description: String
		$approveStatus: String!
		$approvers: [Approver]
		$department: String
		$division: String
		$employeeName: String
		$noteApprove: String
      $shiftId: String
      $leaveStartTime: String
      $leaveEndTime: String
      $leaveHour: String
      $autoApprove: Boolean!
	){
		updateLeaveDocument(
			empCode: $empCode
			docId: 	$docId
			documentDate: $documentDate
			leaveTypeId: $leaveTypeId
			leaveStartDate: $leaveStartDate
			durationType: $durationType
			leaveEndDate: $leaveEndDate
			leaveDay: $leaveDay
			description: $description
			approveStatus: $approveStatus
			approvers:  			$approvers
			department: $department
			division: $division
			employeeName: $employeeName
			noteApprove: $noteApprove
         shiftId: $shiftId
         leaveStartTime: $leaveStartTime
         leaveEndTime: $leaveEndTime
         leaveHour: $leaveHour
         autoApprove: $autoApprove

		){
			errorMessage
		}
	}
`

const deleteAttachmentFile = gql`
	mutation(
		$docId: ID!
		$fileId: ID!
	){
		deleteAttachmentFile(
			docId: $docId
			fileId: $fileId
		){
			errorMessage
		}
	}
`

const destroyWDHospitalDocument = gql`
	mutation(
		$wdHospitalDocumentId: ID!
	){
		destroyWDHospitalDocument(
			wdHospitalDocumentId: $wdHospitalDocumentId
		){
			status
		}
	}
`

const createDelegateApprover = gql`
	mutation(
		$docType: [String!]!
		$fromEmpCode: String
		$toEmpCode: String!
      $isActive: Int!
		$startDate: Date!
		$endDate: Date!
		$note: String
	){
		createDelegateApprover(
			docType: $docType
			fromEmpCode: $fromEmpCode
			toEmpCode: $toEmpCode
			isActive: $isActive
			startDate: $startDate
			endDate: $endDate
			note: $note
		){
			status
		}
	}
`

const revokeDelegateApprover = gql`
	mutation(
		$delegateId: ID!
		$note: String
	){
		revokeDelegateApprover(
			delegateId: $delegateId
			note: $note
		){
			status
		}
	}
`

const cancelExportWDHospital = gql`
	mutation(
		$wdExportId: ID!
		$cancelNote: String
	){
		cancelExportWDHospital(
			wdExportId: $wdExportId
			cancelNote: $cancelNote
		){
			status
		}
	}
`

const createFundRateChange = gql`
	mutation(
		$provEmployeeDeduct: Float
		$fundPolicyId: String
		$status: RequestFundStatus!
	){
		createFundRateChange(
			provEmployeeDeduct: $provEmployeeDeduct
			fundPolicyId: $fundPolicyId
			status: $status
		){
			status
		}
	}
`

const updateFundRateChange = gql`
	mutation(
		$fundRequestId: ID!
		$status: RequestFundStatus
		$provEmployeeDeduct: Float
	){
		updateFundRateChange(
			fundRequestId: $fundRequestId
			status: $status
			provEmployeeDeduct: $provEmployeeDeduct
		){
			status
		}
	}
`

const createFundApplication = gql`
	mutation{
		createFundApplication{
			status
		}
	}
`

const createFundBenefitPerson = gql`
	mutation(
		$benefitPersons: [BenefitPersonInput]
		$fundDocument: [FundDocumentInput]
		$status: RequestFundStatus
	){
		createFundBenefitPerson(
			benefitPersons: $benefitPersons
			fundDocument: $fundDocument
			status: $status
		){
			status
		}
	}
`

const updateFundBenefitPerson = gql`
	mutation(
		$fundRequestId: ID!
		$benefitPersons: [BenefitPersonInput]
		$fundDocument: [FundDocumentInput]
		$status: RequestFundStatus
		$deletedFileId: [String]
		$deletedFundDocumentId: [String]
		$deletedFundBenefitPersonId: [String]
	){
		updateFundBenefitPerson(
			fundRequestId: $fundRequestId
			benefitPersons: $benefitPersons
			fundDocument: $fundDocument
			status: $status
			deletedFileId: $deletedFileId
			deletedFundDocumentId: $deletedFundDocumentId
			deletedFundBenefitPersonId: $deletedFundBenefitPersonId
		){
			status
		}
	}
`

const createFundBenefitPersonFormPDF = gql`
	mutation(
		$benefitPersons: [BenefitPersonInput]
	){
		createFundBenefitPersonFormPDF(
			benefitPersons: $benefitPersons
		){
			linkPDF
		}
	}
`


const multipleUpdateLeaveDocument = gql`
	mutation(
		$bulk: [MultipleUpdate]!
	){
		multipleUpdateLeaveDocument(
			bulk: $bulk
		){
			docId
         message
		}
	}
`


const updateStudyLeaveRequest = gql`
  mutation(    
    $studyLeaveRequestId: ID!
    $empCode: String
    $empName: String
    $position: String
    $empSalary: Decimal
    $empGroup: String
    $departmentName: String
    $organizationCode: String
    $organizationName: String
    $empLevel: String
    $divisionName: String
    $studyLeaveNo: String
    $studyLeaveDocumentNo: String
    $studyLeaveDocumentDate: Date
    $studyLeaveResult: String
    $currentRevision: Int
    $studyLeaveStatus: String
    $studyLeaveRemark: String
    $requestAt: Date
    $requestBy: String
    $createdBy: String
    $updatedBy: String
    $isCancel: Boolean
	$studyLeaveType: String
    $studyLeaveDetail: [StudyLeaveDetailInput]
    $studyStrategy: [StudyStrategyInput]
    $studyLearnRecord: [StudyLearnRecordInput]
    $studyExtend: [StudyExtendInput]
    $studyEducationFee: [StudyEducationFeeInput]
    $studyScholarship: StudyScholarshipInput
    $studyHistory: [StudyHistoryInput]
    $studyAttachment: [StudyAttachmentInput]
	$studyReturnDetail: [StudyReturnDetailInput]
    $deletedFileId: [String]
    $deletedStudyAttachmentId: [String]
    $deletedStudyLeaveDetailId: [String]
    $deletedStudyEducationFeeId: [String]
    $deletedStudyHistoryId: [String]
    $deletedStudyLearnRecordId: [String]
    $deletedStudyExtendId: [String]
    $deletedStudyScholarshipDetailId: [String]
    $deletedStudyScholarshipId: [String]
    $deletedStudyStrategyId: [String]
	$deletedStudyReturnDetailId: [String]
	$subDeptCode: String
	$subDeptName: String
	$childSubDeptCode: String
	$childSubDeptName: String
    ){
      updateStudyLeaveRequest(
        studyLeaveRequestId: $studyLeaveRequestId
        empCode: $empCode
        empName: $empName
        position: $position
        empSalary: $empSalary
        empGroup: $empGroup
        departmentName: $departmentName
        organizationCode: $organizationCode
        organizationName: $organizationName
        empLevel: $empLevel
        divisionName: $divisionName
        studyLeaveNo: $studyLeaveNo
        studyLeaveDocumentNo: $studyLeaveDocumentNo
        studyLeaveDocumentDate: $studyLeaveDocumentDate
        studyLeaveResult: $studyLeaveResult
        currentRevision: $currentRevision
        studyLeaveStatus: $studyLeaveStatus
        studyLeaveRemark: $studyLeaveRemark
        requestAt: $requestAt
        requestBy: $requestBy
        createdBy: $createdBy
        updatedBy: $updatedBy
        isCancel: $isCancel
		studyLeaveType: $studyLeaveType
        studyLeaveDetail: $studyLeaveDetail
        studyStrategy: $studyStrategy
        studyLearnRecord: $studyLearnRecord
        studyExtend: $studyExtend
        studyEducationFee: $studyEducationFee
        studyScholarship: $studyScholarship
        studyHistory: $studyHistory
        studyAttachment: $studyAttachment
		studyReturnDetail: $studyReturnDetail
        deletedFileId: $deletedFileId
        deletedStudyAttachmentId: $deletedStudyAttachmentId
        deletedStudyLeaveDetailId: $deletedStudyLeaveDetailId
        deletedStudyEducationFeeId: $deletedStudyEducationFeeId
        deletedStudyHistoryId: $deletedStudyHistoryId
        deletedStudyLearnRecordId: $deletedStudyLearnRecordId
        deletedStudyExtendId: $deletedStudyExtendId
        deletedStudyScholarshipDetailId: $deletedStudyScholarshipDetailId
        deletedStudyScholarshipId: $deletedStudyScholarshipId
        deletedStudyStrategyId: $deletedStudyStrategyId
		deletedStudyReturnDetailId: $deletedStudyReturnDetailId
		subDeptCode: $subDeptCode
		subDeptName: $subDeptName
		childSubDeptCode: $childSubDeptCode
		childSubDeptName: $childSubDeptName
		){
			status
		}
  }
`

const removeLeaveDocumentDraf = gql`
  mutation (
      $wdLeaveId: String!
  ) {
    removeLeaveDocumentDraf(
      wdLeaveId: $wdLeaveId
    ) {
      status
      message
    }
  }
`;



const checkRemoveLeaveDocumentAsFlow = gql`
	mutation(
		$docNo: String!
      $clientType: String!
      $leaveCancelRequestReason: String
	){
		checkRemoveLeaveDocumentAsFlow(
			docNo: $docNo
			clientType: $clientType
			leaveCancelRequestReason: $leaveCancelRequestReason
		){
			status
         message
		}
	}
`;

const mutipleApproveCancelLeaveDocumentAsFlow = gql`
	mutation(
		$bulk: [mitipleCancleInput]
	){
		mutipleApproveCancelLeaveDocumentAsFlow(
			bulk: $bulk
		){
			status
         message
		}
	}
`;

const approveCancelLeaveDocumentAsFlow = gql`
	mutation(
		$removeLeaveDocumentStatus: ApproveCancelStatus!
      $wdLeaveId: String!
      $leaveCancelRequestId: String!
      $leaveCancelRequestReason: String
	){
		approveCancelLeaveDocumentAsFlow(
			removeLeaveDocumentStatus: $removeLeaveDocumentStatus
			wdLeaveId: $wdLeaveId
			leaveCancelRequestId: $leaveCancelRequestId
			leaveCancelRequestReason: $leaveCancelRequestReason
		){
			status
         message
		}
	}
`;


export default {
	login,
	setupPassword,
	changePassword,
	createConsent,
	sendVerifyCode,
	changeCurrentProfile,
	logout,
	createUserReadNotification,
	createUserResultNotification,
	requestVerifyOTPandSetupPassword,
	resetPassword,
	createTaxDraft,
	updateTaxDraft,
	createAddress,
	updateAddress,
	createPostRead,
	changePhoneNumber,
	createWDHospital,
	updateWDHospital,
	destroyWDHospital,
	destroyWDSlip,
	createLeaveDocument,
	updateLeaveDocument,
	deleteAttachmentFile,
	destroyWDHospitalDocument,
	createDelegateApprover,
	revokeDelegateApprover,
	cancelExportWDHospital,
	createFundRateChange,
	updateFundRateChange,
	createFundApplication,
	createFundBenefitPerson,
	updateFundBenefitPerson,
	createFundBenefitPersonFormPDF,
   multipleUpdateLeaveDocument,
   updateStudyLeaveRequest,
   removeLeaveDocumentDraf,
   checkRemoveLeaveDocumentAsFlow,
   mutipleApproveCancelLeaveDocumentAsFlow,
   approveCancelLeaveDocumentAsFlow
}
